<template>
 	
 	<div v-bind:class="{ invisible: !progress}" id='stepProgressBar'> 
 		<div v-bind:style="{ width: progress + '%' }" class="progress"></div>
 	</div>


</template>

<script>

export default {
  data: function(){ 
    return{
  	}

  },

  computed:{

    progress(){

    	// Steps come from mixin checks.js
    	var steps = Object.keys(this.steps).length - 1;
    	var completed = 0

		if(this.steps.background)
			completed++

		if(this.steps.pictureWall)
			completed++

		if(this.steps.motifs)
			completed++

		if(this.steps.frames)
			completed++

		return (completed * 100) / steps;
    }

  }

}
</script>

<style>

#stepProgressBar{
	height: 2px;
    background: #eeeeee;

    .progress{
    	background: black;
    	height: 2px;
    	transition: width .25s ease; 
    }
}

</style>



// WEBPACK FOOTER //
// StepProgressBar.vue?5b86b408